import { createBrowserRouter } from "react-router"
import { createRoutes } from "src/router/routes"

const createAppRouter = () => {
  return createBrowserRouter(createRoutes(), {})
}

export default createAppRouter
